// business lokalai
import RoyaltyCard from "./royaltycard";
import BusinessDashboard from "./businessdashboard";
import Menu from "./ordering";
import BestDeal from "./deal";
import LokalaiDocument from "./doclokalai";
import Ordering from "./ordering";
import Booking from "./booking"; // 👈 add if you have booking section

// Booking operators
export const bookingMenu = [
  BusinessDashboard,
  { id: "divider-1", type: "divider" },
  Booking,
  BestDeal,
  RoyaltyCard,
  { id: "divider-2", type: "divider" },
  LokalaiDocument,
];

// Ordering operators
export const orderingMenu = [
  BusinessDashboard,
  { id: "divider-1", type: "divider" },
  Ordering,
  BestDeal,
  RoyaltyCard,
  { id: "divider-2", type: "divider" },
  LokalaiDocument,
];

// Loyalty-only operators
export const loyaltyOnlyMenu = [
  BusinessDashboard,
  { id: "divider-1", type: "divider" },
  RoyaltyCard,
  { id: "divider-2", type: "divider" },
  LokalaiDocument,
];

// Standalone loyalty section
export const loyaltyMenu = [RoyaltyCard];
